import english from './english'
import spanish from './spanish'

export default { spanish, english }



// WEBPACK FOOTER //
// ./src/languages/index.js